import { OpenFromEnum } from '@/constant';
import { ISelectApplicantPopup } from '@/services';
import { formatVisaTime } from '@/utils';

import { includes } from 'ramda';

import { ColumnTypes } from '../common/table/type';
import SelectApplicantRelationship from './select-applicant-relationship';

export const initialValues = {
	applicantName: '',
};

const HAVE_RELATION = [OpenFromEnum.LM1_03, OpenFromEnum.RM1_03];

export const rowKey = 'id';

export const getColumns = ({
	openFrom,

	relationshipRefs,
}: {
	openFrom?: OpenFromEnum;
	relationshipRefs: React.MutableRefObject<Record<number, string>>;
}): ColumnTypes => [
	{
		title: `ID`,
		dataIndex: 'id',
		key: 'id',
		align: 'center',
		fixed: 'left',
	},

	{
		title: '성',
		dataIndex: 'firstName',
		key: 'firstName',
		align: 'center',
		fixed: 'left',
	},
	{
		title: '이름',
		dataIndex: 'lastName',
		key: 'lastName',
		align: 'center',
		fixed: 'left',
	},

	{
		title: '생년월일',
		dataIndex: 'birthDate',
		key: 'dob',
		align: 'center',
		fixed: 'left',
	},
	{
		title: '입국일',
		dataIndex: 'entryDate',
		key: 'entryDate',
		align: 'center',
		fixed: 'left',
	},
	{
		title: '체류자격',
		dataIndex: 'visaName',
		key: 'visaName',
		align: 'center',
		fixed: 'left',
	},
	{
		title: '체류기간',
		dataIndex: 'visaTime',
		key: 'visaTime',
		align: 'center',
		fixed: 'left',
		width: 120,
		render: (value, record) => {
			return <span>{formatVisaTime(record?.visaTime)}</span>;
		},
	},
	{
		title: '추천자와의 관계',
		dataIndex: 'relationship',
		key: 'relationship',
		align: 'center',
		fixed: 'left',
		width: 160,
		render: (value, record) => {
			return (
				<SelectApplicantRelationship
					openFrom={openFrom}
					relationshipRefs={relationshipRefs}
					record={record as ISelectApplicantPopup}
				/>
			);
		},
		hidden: !includes(openFrom, HAVE_RELATION),
	},
];
